module.exports = __webpack_public_path__ + "img/logo-metas-home.e09e0861.png";